'use strict';

import 'angular';

import formDirective from './directive';

const MODULE_NAME = 'brg.rest.form';

var app = angular.module(MODULE_NAME, [
	'ui.bootstrap',
	'toastr',
    'ngFileUpload',
]);
app.directive('brgRestForm', formDirective);

export default MODULE_NAME;
